import ReactDOM from 'react-dom/client'

import App from './App'
import '@my-org/icons716'

ReactDOM.createRoot(document.getElementById('root')).render(<App />)
